import React, { useEffect, useState } from 'react';
import { classNames } from '@utils';
import Tooltip from '@components/tooltip/Tooltip';
import { Panel, IconFormInfo } from '@ftdr/blueprint-components-react';
import { useWindowSize } from 'react-use';
import REText from '@components/wrappedBDS/REText';
import { IsTheme, Theme } from '@app/core/featureToggle';

interface Props {
  className?: string;
  heading: string;
  headingHelper?: string;
  variant?: 'shadowed' | 'bordered' | 'none';
  mobileVariant?: 'shadowed' | 'bordered' | 'none';
}

const CardBox: React.FC<Props> = (props) => {
  const { width } = useWindowSize();
  const [isMobile, setIsMobile] = useState(width < 480);

  useEffect(() => {
    setIsMobile(width < 480);
  }, [width]);

  return (
    <Panel
      padding="none"
      border={!IsTheme(Theme.Ahs2024) && (isMobile ? props.mobileVariant : props.variant) === 'bordered' ? '1' : '0'}
      borderColor="gray-300"
      rounded={isMobile ? 'none' : 'md'}
      shadow={(isMobile ? props.mobileVariant : props.variant) === 'shadowed'}
      className={classNames([props.className, 'order-plans'])}

    >
      <Panel
        roundedT="md"
        roundedB="none"
        border="0"
        backgroundColor="white"
        padding={
          IsTheme(Theme.Ahs2024)
            ? (isMobile ? 'md' : 'none')
            : (isMobile ? 'md' : 'lg')
        }
        className={classNames(['flex items-center text-left'])}
      >
        <REText variant="heading-04" className="my-0">
          {props.heading}
        </REText>

        {props.headingHelper && (
          <Tooltip placement="right" content={<p className="text-left">{props.headingHelper}</p>}>
            <span className="ml-2">
              <IconFormInfo color="gray" />
            </span>
          </Tooltip>
        )}
      </Panel>

      <div className="overflow-hidden">
        <Panel
          roundedT="none"
          roundedB="md"
          border="0"
          padding={IsTheme(Theme.Ahs2024)
            ? (isMobile ? 'lg' : 'none')
            : (isMobile ? 'lg' : 'xl')}
          paddingT="none"
          className={`${IsTheme(Theme.Ahs2024) ? 'pt-2' : ''} pl-0`}
        >
          {props.children}
        </Panel>
      </div>
    </Panel>
  );
};

CardBox.defaultProps = {
  variant: 'shadowed',
  mobileVariant: 'shadowed',
};

export default CardBox;
